import Ajax from '@/lib/ajax'
import Util from '@/lib/util'

interface ShippingAddressDto {
  name: string
  phone: string
  province: string
  city: string
  district: string
  address: string
  zipCode: string
}

export default {
  /**
   * 获取订单列表
   * @param pageSize
   * @param currentPage
   */
  getOrderList(
    pageSize: number,
    currentPage: number,
    orderProductType: number,
    OrderNo?: string,
    ShippingInfo?: string,
    StartTime?: string,
    EndTime?: string,
    OrderFullStatus?: number,
    OrderType?: number,
    UserId?: string,
    productId?: string,
    storeId?: string,
    productCategoryId?: string,
    OrderSourceType?: number
  ) {
    let params = {
      OrderNo: OrderNo,
      ShippingInfo: ShippingInfo,
      StartTime: StartTime,
      EndTime: EndTime,
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      orderProductType
    }

    if (OrderFullStatus != null) {
      params['OrderStatus'] = OrderFullStatus
    }
    if (OrderType != null) {
      params['OrderType'] = OrderType
    }
    if (UserId != null) {
      params['UserId'] = UserId
    }
    if(productId) {
      params['productId'] = productId
    }
    if(storeId) {
      params['storeId'] = storeId
    }
    if(productCategoryId) {
      params['productCategoryId'] = productCategoryId
    }
    if(OrderSourceType != null) {
      params['OrderSourceType'] = OrderSourceType
    }
    return Ajax.get('/api/OrderManagement/order', {
      params: params,
    })
  },

  getPrintList(ids: any[]) {
    return Ajax.get('/api/OrderManagement/order/list' + Util.serialize({ ids }))
  },

  /**
   * 订单详情
   */
  orderDetail(id: string) {
    return Ajax.get(`/api/OrderManagement/order/${id}`)
  },
  // 修改订单商品数量
  changeOrderItemCount(orderItemId: string, count: number) {
    return Ajax.put(`/api/OrderManagement/order/ChangeOrderItemCount?orderItemId=${orderItemId}&count=${count}`)
  },
  /**
   * 修改订单收货人地址
   */
  updateUserAddress(id: string, address: ShippingAddressDto) {
    return Ajax.put(`/api/OrderManagement/order/address/${id}`, address)
  },

  /**
   * 获取订单物流信息
   */
  getShipment(OrderIds: []) {
    let list = OrderIds || []
    let params = ''
    list.forEach((item, index) => {
      if (index === 0) {
        params = '?'
      }
      params += 'OrderIds=' + item
      if (index < list.length - 1) {
        params += '&'
      }
    })
    return Ajax.get(`/api/OrderManagement/order/shipment${params}`)
  },

  /**
   * 订单发货
   */
  updateShipment(orderId: string, orderItemIdArray: string, expressCompanyName: string, shipmentNumber: string) {
    return Ajax.put(`/api/OrderManagement/order/shipment/${orderId}`, {
      orderItemIdArray: orderItemIdArray,
      expressCompanyName: expressCompanyName,
      shipmentNumber: shipmentNumber,
    })
  },

  /**
   * 批量取消订单
   * @param ids
   */
  cancelOrder(ids: any[]) {
    return Ajax.put(`/api/OrderManagement/order/cancel`, ids)
  },

  /**
   * 删除订单(只能删除已取消订单)
   * @param ids
   */
  deleteOrder(ids: []) {
    let list = ids || []
    let params = ''
    list.forEach((item, index) => {
      if (index === 0) {
        params = '?'
      }
      params += 'ids=' + item
      if (index < list.length - 1) {
        params += '&'
      }
    })
    return Ajax.delete(`/api/OrderManagement/order${params}`)
  },

  /**
   * 获取订单操作日志
   * @param id
   */
  getOrderNote(id: string) {
    return Ajax.get(`/api/OrderManagement/OrderNote/all/${id}`)
  },
  /**
   * 设置订单为已支付
   */
  changeOrderToAreadypay(arr: any[]) {
    return Ajax.post(`/api/OrderManagement/order/ChangeOrderToAlreadyPaid`, arr)
  },
  /**
   * 更新包裹快递信息
   * @param id
   * @param expressCompanyName
   * @param shipmentNumber
   */
  updatePackages(orderId: string, id: number, expressCompanyName: string, shipmentNumber: string) {
    return Ajax.put(`/api/OrderManagement/order/express_package/${orderId}`, {
      id: id,
      expressCompanyName: expressCompanyName,
      shipmentNumber: shipmentNumber,
    })
  },

  /**
   * 不需要添加包裹的发货
   * @param id
   * @param expressCompanyName
   * @param shipmentNumber
   */
  shipmentNoExpressPackage(orderId: string, id: number, expressCompanyName: string, shipmentNumber: string) {
    return Ajax.put(`/api/OrderManagement/order/shipmentNoExpressPackage/${orderId}`, {
      id: id,
      expressCompanyName: expressCompanyName,
      shipmentNumber: shipmentNumber,
    })
  },

  /**
   * 获取物流信息
   * @param expressCompanyId
   */
  getTrackInfo(expressCompanyId: string, ShipperCode: string) {
    return Ajax.get(`/api/MallConfigManagement/track/${expressCompanyId}?ShipperCode=${ShipperCode}`)
  },
  /**
   * 修改实付价格
   */
  updatePayAmount(data: { orderId: string; payAmount: number }) {
    return Ajax.post(`/api/OrderManagement/order/changePayAmount`, data)
  },
  exportExcel(
    pageSize: number,
    currentPage: number,
    OrderNo?: string,
    ShippingInfo?: string,
    // CreationTime?: string,
    OrderFullStatus?: number,
    OrderType?: number,
    UserId?: string,
    OrderIds?: null | any[],
    StartTime?: string,
    EndTime?: string,
    orderProductType?: number
  ) {
    let params = {
      OrderNo: OrderNo,
      ShippingInfo: ShippingInfo,
      // CreationTime: CreationTime,
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      StartTime,
      EndTime,
      orderProductType
    }

    if (OrderFullStatus != null) {
      params['OrderFullStatus'] = OrderFullStatus
    }
    if (OrderType != null) {
      params['OrderType'] = OrderType
    }
    if (UserId != null) {
      params['UserId'] = UserId
    }
    if (OrderIds) {
      params['OrderIds'] = OrderIds
    }
    return Ajax.get(`/api/OrderManagement/order/exportOrderFile${Util.serialize(params)}`, {
      responseType: 'blob',
    })
  },
  erpOrder(orderNo: string) {
    return Ajax.post(`/api/GuanYiErpManagement/erpOrder?orderNo=${orderNo}`)
  },
  // 异步导出订单
  exportExcelSync(
    pageSize: number,
    currentPage: number,
    OrderNo?: string,
    ShippingInfo?: string,
    OrderFullStatus?: number,
    OrderType?: number,
    UserId?: string,
    OrderIds?: null | any[],
    StartTime?: string,
    EndTime?: string
  ) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
    }
    if(OrderNo) {
      params['OrderNo'] = OrderNo
    }
    if(ShippingInfo) {
      params['ShippingInfo'] = ShippingInfo
    }
    if(StartTime) {
      params['StartTime'] = StartTime
    }
    if(EndTime) {
      params['EndTime'] = EndTime
    }
    if (OrderFullStatus != null) {
      params['OrderFullStatus'] = OrderFullStatus
    }
    if (OrderType != null) {
      params['OrderType'] = OrderType
    }
    if (UserId && UserId != null) {
      params['UserId'] = UserId
    }
    if (OrderIds && OrderIds.length) {
      params['OrderIds'] = OrderIds
    }
    return Ajax.get(`/api/OrderManagement/order/CreateExportOrderTask${Util.serialize(params)}`)
  },
  // 根据商品分类筛选订单项
  filterOrderItemsById(orderId: string, categoryIds: any[]) {
    let obj = {
      orderId,
      categoryIds
    }
    return Ajax.post(`/api/OrderManagement/order/GetOrderItems`, obj)
  },
  // 订单详情里面的根据订单id获取分类
  getClassifyByOrderId(id: string) {
    return Ajax.get(`/api/OrderManagement/order/GetOrderItemsCategory?orderId=${id}`)
  },
  // 批量修改订单状态
  changeOrderStatus(orderStatus: number, ids: string[]) {
    return Ajax.post(`/api/OrderManagement/order/ChangOrderStatus?orderStatus=${orderStatus}`, ids)
  },
  // 订单审核预览
  examineOrderPrew(orderNo: string) {
    return Ajax.post(`/api/OrderManagement/order/PrePay?orderNo=${orderNo}`)
  },
  // 订单审核
  examineOrder(data: any) {
    return Ajax.post(`/api/OrderManagement/order/Payment`, data)
  },
  // 释放定金
  releaseDeposit(orderNo: string) {
    return Ajax.post(`/api/OrderManagement/order/ReleaseOrder/${orderNo}`)
  },
  // 检查订单商品库存
  checkOrderProductStock(orderNo: string) {
    return Ajax.post(`/api/OrderManagement/order/CheckOrderStock?orderNo=${orderNo}`)
  }
}
